import { render, staticRenderFns } from "./UploadNexus.vue?vue&type=template&id=1bf7788a&scoped=true"
import script from "./UploadNexus.vue?vue&type=script&lang=ts"
export * from "./UploadNexus.vue?vue&type=script&lang=ts"
import style0 from "./UploadNexus.vue?vue&type=style&index=0&id=1bf7788a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf7788a",
  null
  
)

export default component.exports